import path from 'app/native/node/path';
import { FRONT_END_PATH } from 'app/redux/global/constants';
import _ from 'lodash';
import PmsExporter, { ImagesType, PMSConfigurationType, StudyType } from './PmsExporter';
import { Patient } from 'app/interfaces/Patient';

export namespace FileMaker {
  export const ORIGIN = 'FILE_MAKER';
  export const CONFIGURATION_KEY = 'file_maker';
  export const LABEL = 'FileMaker';
  export const DEFAULT_SPECIES_ALIASES = {
    AQU: 'other', //AQUACULTURE
    BOV: 'other', //BOVINS
    CAP: 'other', //CAPRINS
    CNS: 'dog', //CHIEN
    CTS: 'cat', //CHAT
    EQU: 'other', //EQUIN
    GIB: 'other', //GIBIER
    LAP: 'rabbit', //LAPINS
    OIS: 'bird', //OISEAUX
    OVI: 'other', //OVINS
    PAS: 'other', //LOCAUX MATERIEL
    PIG: 'bird', //PIGEONS
    POR: 'other', //PORCINS
    RON: 'rodent', //RONGEURS
    TES: 'other', //TOUTES ESPECES
    TO: 'reptile', //TORTUES
    VIS: 'rodent', //VISONS
    VOL: 'bird', //VOLAILLES
    API: 'other', //APICULTURE
    REP: 'reptile', //REPTILES
    FUR: 'ferret', //FURETS
    NAC: 'other', //NAC
  } as const;
}

export default class FileMakerExporter extends PmsExporter {
  exportLink = async (exportDirectory: string, pmsId: string, studyId: string) => {
    this.fileSystemPromises.writeFile(
      path().join(exportDirectory, `${pmsId}_study_link.txt`),
      FRONT_END_PATH + '/' + this.intl.locale + '/online?study_ids[]=' + studyId
    );
  };

  exportDataToPMS = async (
    { exportDirectory }: PMSConfigurationType = {},
    currentStudy: StudyType,
    patient: Patient,
    images: ImagesType = []
  ): Promise<PromiseSettledResult<void>[]> => {
    // PMS not configured, don't bother user with this
    if (!exportDirectory) {
      console.warn('exportDirectory is not configured cannot export data to PMS');
      return undefined;
    }

    const pmsId: string = currentStudy?.pms_id;
    if (!pmsId) {
      console.warn('Patient pms_id is required to export data to PMS');
      return undefined;
    }

    return Promise.allSettled([...this.exportImages(exportDirectory, pmsId, images), ,]);
  };
}
